export const environment = {
    production: false,
    logLevel: 'INFO',
    settings:
    {
        authUrl: "https://portalserver-demo.acimobills.com/auth/api",
        portalUrl: "https://portalserver-demo.acimobills.com/portal/api",
        regions: [
            {"region": "demo", "baseUrl": "https://demo.walletron.com/Walletron/api"}
        ]
    }
};